import React, { useEffect } from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import {Button, Table ,Row,Col} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import Loader from '../components/Loader'
import {createProduct, deleteProduct, listProducts} from '../actions/productActions'
import { PRODUCT_CREATE_RESET } from '../constants/productConstants'
import Paginate from '../components/Paginate'

const ProductListScreen = ({history,match}) => {

    const pageNumber=match.params.pageNumber||1

    const dispatch=useDispatch()

    const productList=useSelector(state=>state.productList)
    const {loading,error,products,page,pages}=productList
    
    const userLogin=useSelector(state=>state.userLogin)
    const {userInfo}=userLogin

    const productDelete=useSelector(state=>state.productDelete)
    const {loading:loadingDelete,error:errorDelete,success:successDelete}=productDelete
    
    const productCreate=useSelector(state=>state.productCreate)
    const {loading:loadingCreate,error:errorCreate,success:successCreate,product:createdProduct}=productCreate

    useEffect(() => {
        dispatch({type:PRODUCT_CREATE_RESET})
        if(!userInfo.isAdmin){
            history.push('/login')
        }
        if(successCreate){
            history.push(`/admin/products/${createdProduct._id}/edit`)
        }else{
            dispatch(listProducts('',pageNumber))
        }
    }, [dispatch,history,userInfo,successDelete,successCreate,createdProduct,pageNumber])


    const deleteHandler=(product)=>{
        if(window.confirm('Are you sure ?')){
            dispatch(deleteProduct(product))
        }
    }

    const createProductHandler=()=>{
        dispatch(createProduct())
    }

    return (
        <>
            <Row className="align-items-center">
                <Col>
                    <h1>Products</h1>
                </Col>
                <Col className="text-right">
                    <Button className="my-3" onClick={createProductHandler}>
                        <i className="fas fa-plus"></i> Create Products
                    </Button>
                </Col>
            </Row>
            {loadingDelete&&<Loader></Loader>}
            {errorDelete&&<Message variant="danger">{errorDelete}</Message>}
            {loadingCreate&&<Loader></Loader>}
            {errorCreate&&<Message variant="success">{errorCreate}</Message>}
            {loading?<Loader></Loader>:error?<Message variant="danger">{error}</Message>:(
                <>
                <Table striped bordered hover responsive className="table-sm">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>NAME</th>
                            <th>PRICE</th>
                            <th>CATEGORY</th>
                            <th>BRAND</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            products.map((product)=>{
                                return(<tr key={product._id}>
                                    <td>{product._id}</td>
                                    <td>{product.name}</td>
                                    <td>Rs {product.price}</td>
                                    <td>{product.category}</td>
                                    <td>{product.brand}</td>
                                    <td>
                                        <LinkContainer to={`/admin/products/${product._id}/edit`}>
                                            <Button variant='light' className="btn-sm">
                                                <i className="fas fa-edit"></i>
                                            </Button>
                                        </LinkContainer>
                                        <Button variant="danger" className="btn-sm" onClick={()=>{deleteHandler(product)}}>
                                            <i className="fas fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>)
                            })
                        }
                    </tbody>
                </Table>
                <Paginate pages={pages} page={page} isAdmin={true}></Paginate>
                </>
            )}   
        </>
    )
}

export default ProductListScreen
